import React from 'react';

import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    makeStyles
} from '@material-ui/core';

import { InfoOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 30
    },
    gutters: {
        padding: 0,
        paddingBottom: 10
    },
    info: {
        color: theme.palette.text.secondary
    }
}));

function InformativoFaturamento() {
    const classes = useStyles();

    return <ListItem classes={{ gutters: classes.gutters }}>
        <ListItemIcon classes={{ root: classes.root }} >
            <InfoOutlined className={classes.info} />
        </ListItemIcon>
        <ListItemText>
            <Typography variant='caption'
                className={classes.info}>
                O pagamento pode demorar até 2 dias úteis para ser processado.
                    </Typography>
        </ListItemText>
    </ListItem>
}

export default InformativoFaturamento;